<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ErrorWrapper } from '@utils/error-handler'
import { ADMIN_ROLE, COLLEGE_ROLE } from '@utils/constant'
import {
  meetingComputed,
  meetingListMethod,
  siteListMethod,
  authComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Meeting List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      COLLEGE_ROLE: COLLEGE_ROLE,
      isLoading: true,
      lists: [],
      fields: [
        {
          value: 'title',
          text: 'Title',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'description',
          text: 'Description',
          sortable: true,
          colType: 'default',
        },
        { value: 'date', text: 'Date', sortable: true, colType: 'default' },
        {
          value: 'meetingtime',
          text: 'Time',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'meeting_id',
          text: 'Meeting Id',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        { key: 'title', label: 'Title', colType: 'default' },
        { key: 'description', label: 'Description', colType: 'default' },
        { key: 'meeting_id', label: 'Meeting Id', colType: 'default' },
        { key: 'date', label: 'Date', colType: 'default' },
        { key: 'start_time', label: 'Time', colType: 'time' },
        {
          key: 'createdAt',
          label: 'Added On',
          colType: 'date',
        },
      ],
      showModal: false,
      zoom_token: '',
      apiKey: '',
      apiSecret: '',
    }
  },
  computed: {
    ...meetingComputed,
    ...authComputed,
  },
  mounted() {
    this.getListOfMeeting()
    this.getListOfCollege()
  },
  methods: {
    ...meetingListMethod,
    ...siteListMethod,

    // get list of platform
    getListOfCollege() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var self = this
          siteconfig.forEach((element) => {
            if (element.platform_id === self.currentUser.user.platform_id) {
              self.apiKey = element.api_key
              self.apiSecret = element.api_secret
            }
          })
        })
        .catch((_error) => {})
    },

    // Get list of all students role wise
    getListOfMeeting() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 10,
        sort: 'date',
        order: '1',
      }
      this.fetchMeetingList({ filter })
        .then((meetingList) => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    saveZoomToken() {
      let Data = {
        api_key: this.apiKey,
        api_secret: this.apiSecret,
      }

      this.updateToken({ Data })
        .then((res) => {
          this.isLoading = false
          this.showModal = false
          this.$bvModal.hide('modal-1')
          this.$bvToast.toast('Zoom Detail Updated Successfully', {
            title: `Success`,
            toaster: 'b-toaster-top-right',
            solid: true,
            variant: 'success',
            appendToast: false,
          })
          this.$router.push({ name: 'meeting.list' })
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.assignmentError = getError.message
          this.isAssignmentError = true
        })
    },

    handleRoute() {
      this.$router.push({ name: 'meeting.add' })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <button
              v-if="role !== COLLEGE_ROLE"
              id="show-modal"
              class="btn btn-info"
              @click="handleRoute"
              ><i class="ti-plus"></i>Add Live Class</button
            >&nbsp;
            <b-button
              v-if="role === COLLEGE_ROLE"
              v-b-modal.modal-1
              class="btn btn-info zoom-btn"
              variant="outline-info"
              ><i class="ti-plus"></i>Add Zoom Credential</b-button
            >

            <b-modal id="modal-1" hide-footer title="Add Zoom Detail">
              <div class="modal-content">
                <div class="modal-body">
                  <b-form
                    data-parsley-validate
                    novalidate
                    @submit.prevent="saveZoomToken"
                  >
                    <b-form-group label="Zoom Api Key" label-for="input-1">
                      <b-form-input
                        id="input-2"
                        v-model="apiKey"
                        type="text"
                        placeholder="Add Api Key"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group label="Zoom Api Secret" label-for="input-1">
                      <b-form-input
                        id="input-2"
                        v-model="apiSecret"
                        type="password"
                        placeholder="Add Api Secret"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="button-group" class="mt-4">
                      <b-button
                        v-if="!isLoading"
                        type="submit"
                        variant="primary"
                        >Save</b-button
                      >
                      <b-button
                        v-else
                        type="submit"
                        variant="primary"
                        class="btn-block"
                        disabled
                      >
                        <b-spinner small></b-spinner>Loading...
                      </b-button>
                    </b-form-group>
                  </b-form>
                </div>
              </div>
            </b-modal>

            <div class="mt-2">
              <Table
                :items="meetingList.docs ? meetingList.docs : []"
                :fields="fields"
                :display-fields="displayFields"
                :bordered="true"
                :viewbtn="true"
                :joinbtn="true"
                :deletebtn="true"
                :editbtn="true"
                :copybtn="true"
                :liveclass="true"
              ></Table>
            </div>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.zoom-btn {
  color: white;
}
</style>
